import { z } from 'zod'
import { CriticalitySchema } from '@omnea-app/packages/universal/documents/constants'

export const DocumentReviewFindingCitationAgentInputSchema = z.object({
  type: z.literal('document_review_finding'),
  fileName: z.string().describe('Verbatim filename of the uploaded file whose review contains the cited finding'),
  ruleLabel: z
    .string()
    .describe(
      'The exact ruleLabel of the finding being cited — the rule name only, excluding the parenthesised criticality. Example: for `- Dates & Term (informational): FAIL. …`, use `Dates & Term`, never `Dates & Term (informational)`.'
    ),
  anchor: z.string().trim().min(1).describe("Verbatim phrase copied directly from the finding's `explanation` text."),
  questionName: z.string().describe('The question name of the file upload question'),
  formTitle: z.string().describe('The form title containing the file upload question'),
})

export const DocumentReviewFindingCitationResolvedSchema = z.object({
  sourceType: z.literal('document_review_finding'),
  sourceLabel: z.string(),
  ruleLabel: z.string(),
  criticality: CriticalitySchema,
  status: z.enum(['pass', 'fail', 'not_found', 'not_applicable', 'error']),
  anchor: z.string(),
  fileStoreId: z.string(),
  documentReviewId: z.string(),
  documentTypeId: z.string().optional(),
})
export type DocumentReviewFindingCitationResolved = z.infer<typeof DocumentReviewFindingCitationResolvedSchema>
